module.exports = __webpack_public_path__ + "img/project_14.d33d7c0a.jpg";